// User settings client → webwalker-core.
// Paths/verbs are locked by tests/unit/coreContract*; do not change without updating contracts.

import Api from "@/api/Api";

export default {
  updateUser(data) {
    return Api().patch("/user", data);
  },
  sendVerifyingEmail(data) {
    return Api().post("/send-verifying-email", data);
  },
};
